import { getMonths, getMonthsStaying } from './DateRangeHandler';

export const getMonthsFirstPayment = (checkIn, checkOut, payments) => {
  const months = getMonths(checkIn, checkOut);

  return parseInt(
    months[payments.findIndex(price => price === 0 || price === '0')],
    10
  );
};

export const getRentableUnitPrice = (
  type,
  minimumPrice,
  currencyCode,
  pricesByMonth,
  fixedPrice,
  hasPriceRangeToggle,
  { moveIn, moveOut } = {},
  { flexibleMoveIn, flexibleMoveOut } = {}
) => {
  const monthsStaying = getMonthsStaying(
    { moveIn, moveOut },
    { flexibleMoveIn, flexibleMoveOut }
  );

  const price = {
    type,
    amount: minimumPrice,
    currencyCode,
    fixedPrice,
    seasonalPrice: null,
    isSeasonalPriceFeatureOn: hasPriceRangeToggle
  };

  if (type !== 'byMonth') {
    return price;
  }

  const seasonalPrice = Object.keys(pricesByMonth)
    .filter(
      month =>
        pricesByMonth[month] !== 'PriceByMonth' &&
        (!monthsStaying || monthsStaying.includes(month))
    )
    .map(month => pricesByMonth[month])
    .sort((minPrice, maxPrice) => minPrice - maxPrice);

  const min = seasonalPrice[0];
  const max = seasonalPrice[seasonalPrice.length - 1];

  if (min === max) {
    price.fixedPrice = min;
    price.type = 'fixed';
    price.amount = price.fixedPrice;
  } else {
    price.seasonalPrice = { min, max };
  }
  return price;
};

export default { getMonthsFirstPayment, getRentableUnitPrice };
